(async () => {
    await import('bootstrap');
})();